export { default } from './ProductEdit'


// WEBPACK FOOTER //
// ./src/scenes/Administration/Product/ProductEdit/index.js